import { gql } from '@apollo/client'
import { IS_VERBOSE } from 'config/development'
import { getSyntheticsGraphClient } from 'rfx/lib/subgraph'
import { useChainId } from 'rfx/lib/chains'
import useSWR from 'swr'
import dayjs from 'dayjs'
import commonPoolStore from '@store/commonPoolStore'

export const useSharePrices = () => {
  const { chainId } = useChainId()
  const client = getSyntheticsGraphClient(chainId)
  const selectedVault = commonPoolStore((store) => store.selectedVault)

  const { data } = useSWR(
    `share-prices-historical-${selectedVault.value}-${chainId}`,
    {
      fetcher: async () => {
        try {
          const query = gql(`
            {
            sharePrices(
                orderBy:timestamp
                orderDirection:desc
                first: 500
                where: { commonPool : "${selectedVault.value.toLowerCase()}"}
            ) {
                price
                timestamp
            }
        }`)
          const { data } = await client!.query({
            query,
            fetchPolicy: 'no-cache',
          })
          return data.sharePrices
            .map((item: { price: number; timestamp: number }) => {
              return {
                price: parseFloat(
                  (item.price * Math.pow(10, -30)).toFixed(4).toString(),
                ),
                date: dayjs(item.timestamp * 1000).format('MMM D, YYYY hA'),
              }
            })
            .reverse()
        } catch (err) {
          // eslint-disable-next-line no-console
          IS_VERBOSE && console.log('🚀 ~ fetcher: ~ err:', err)
          return 0
        }
      },
    },
  )

  return data
}
